import { h, Component } from 'preact';
import { sidebarPopUps } from 'helpers/airportData.js';
import { joinClasses } from 'utils/utils';
import Controls from 'components/bolt/controls/controls.js';
import s from 'components/bolt/airport/sidebar.sss';
import Store from 'store/store';

export default class Sidebar extends Component {
	constructor(props) {
		super(props);
		this.onWindowResize = this.onWindowResize.bind(this);
		this.sections = sidebarPopUps.filter(s => !s.disabled);
		this.btnsIncludesShowtimes = !sidebarPopUps.find(popUp => popUp.id == 'showtimes')?.disabled;
		this.state = {...this.state, scale: 1};
	}

	componentDidMount() {
		window.addEventListener('resize', this.onWindowResize);
		this.calculateSidabarScale();
		
		this.rectsTimer = setTimeout(() => {
			this.getButtonRects();
		}, 500);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.isOpen !== this.props.isOpen) {
			this.rectsTimer = setTimeout(() => {
				this.getButtonRects();
			}, 800);
		}
		if (prevProps.airportRect !== this.props.airportRect) {
			this.rectsTimer = setTimeout(() => {
				this.getButtonRects();
			}, 200);
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onWindowResize);
		clearTimeout(this.rectsTimer);
	}

	onWindowResize() {
		this.getButtonRects();
		this.calculateSidabarScale();
	}

	getButtonRects() {
		const { airportRect, setSideButtonRects } = this.props;
		const buttonRects = {};
		this.sections.forEach((section => {
			const buttonRect = this[`${section.id}Button`]?.getBoundingClientRect();
			if (buttonRect) {
				buttonRects[section.id] = {
					x: buttonRect?.x,
					left: buttonRect?.left,
					top: buttonRect?.top - airportRect?.top,
					y: buttonRect?.y - airportRect?.y,
					centerX: buttonRect?.x + (buttonRect?.width / 2),
					centerY: buttonRect?.y + (buttonRect?.height / 2),
				};
			}
		}));
		setSideButtonRects(buttonRects);
	}

	calculateSidabarScale() {
		let scale = 1;
		const {client} = this.props;
		// Only set scale state if short desktop
		if(client?.isDesktopWidth && window.innerHeight < 738){
			scale = window.innerHeight / 738;
		}
		this.setState({ scale });
	}

	openExternalLink(link) {
		window.open(link, '_blank');
	}

	handleIconClick(section) {

		Store.emit('CUSTOM_EVENT', {
			category: 'central-navigation',
			action: 'navigation-panel-click',
			label: section.id
		});

		if (section.link) {
			this.openExternalLink(section.link);
			return;
		}
		const { toggleWindow } = this.props;
		if (section.popUp) {
			toggleWindow(section.id);
		}
	}

	renderIcon(section) {
		const { imageRoot, isOpen, openedWindows, copy } = this.props;
		const isActive = openedWindows[openedWindows.length - 1] === section.id;
		const isIdle = openedWindows.includes(section.id) && !isActive;

		const iconLabel = copy['$' + section.id].title;
		
		let hasLongWord = false;
		iconLabel.split(' ').forEach(word => {
			if (word.length > 12 ) {
				hasLongWord = true;
			}
		});

		return (
			<button
				key={`${section.id}-button`}
				class={
					joinClasses(
						s.iconButton,
						this.btnsIncludesShowtimes && s.btnsIncludesShowtimes,
						isOpen && s.show,
						isActive && s.active,
						isIdle && s.idle
					)}
				ref={($ref) => this[`${section.id}Button`] = $ref}
				onClick={() => this.handleIconClick(section)}
			>
				<img class={s.icon} src={`${imageRoot}/airport/${section.icon}`} alt={section.popUp?.copy?.altText} />
				{section.activeIcon && <img class={s.activeIcon} src={`${imageRoot}/airport/${section.activeIcon}`} />}
				{section.idleIcon && <img class={s.idleIcon} src={`${imageRoot}/airport/${section.idleIcon}`} />}
				{section.hoverIcon && <img class={s.hoverIcon} src={`${imageRoot}/airport/${section.hoverIcon}`} />}
				<div class={joinClasses(s.iconLabel, hasLongWord && s.hasLongWord)}><p dangerouslySetInnerHTML={{ __html: iconLabel }} /></div>
			</button>
		);
	}


	render({ isOpen, castleRect, client, toggleMute, toggleMotion, toggleLegals, muted, motionPaused, legalsOpen, imageRoot, currentPage, copy }) {
		let panelStyle = {};

		if (client?.isDesktopWidth) {
			panelStyle = {
				// update vertical offset based on whether content height needs to be reduced to fit screen height
				top: (castleRect?.y || castleRect?.top || 0) + (0.25 * castleRect.width * this.state.scale) - (this.sections.length > 6 ? 52 : 0)
			};
		}

		// potentially no passport
		const shortPanel = this.sections.length < 6;
		// Only add sidebar scaling if sidebar contains more than 6 items
		const longPanel = this.sections.length > 6;

		return (
			<div class={s.container} style={`--sidebar-scale: ${ this.state.scale }` }>
				<div class={joinClasses(s.panel, shortPanel && s.shortPanel, isOpen && s.open, client?.isDesktopWidth && longPanel && s.longPanel)} style={panelStyle}>
					{this.sections.map(section => this.renderIcon(section))}
				</div>
				{!client?.isDesktopWidth && (
					<Controls
						toggleMute={toggleMute}
						toggleMotion={toggleMotion}
						toggleLegals={toggleLegals}
						muted={muted}
						motionPaused={motionPaused}
						legalsOpen={legalsOpen}
						imageRoot={imageRoot}
						currentPage={currentPage}
						inSidebar
						sidePanelOpen={isOpen}
						copy={copy}
						legalsPromptCopy={copy.$legalsPromptMobile}
					/>
				)}
			</div>
		);
	}
}
